import { render, staticRenderFns } from "./TwoTabsPopUp.vue?vue&type=template&id=529e3eff&scoped=true&"
import script from "./TwoTabsPopUp.vue?vue&type=script&lang=js&"
export * from "./TwoTabsPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e3eff",
  null
  
)

export default component.exports